import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import {  Repository } from 'typeorm';

import { StocktransferEntity } from './stock-transfer-entity';
import { StockItemstransferEntity } from './stock-transfer-items-entity';
import { CommonResponseModel, StockTransferDto } from '@project-management-system/shared-models';
import { StocksRepository } from '../stocks/repository/stocks.repository';
import { PlantsRepository } from '../plants/plants.repo';

@Injectable()
export class StockTransferService{
    constructor(
        @InjectRepository(StocktransferEntity)
        private repo: Repository<StocktransferEntity>,
        @InjectRepository(StockItemstransferEntity)
        private itemsRepo: Repository<StockItemstransferEntity>,
        private stockRepo:StocksRepository,
        private plantsRepository:PlantsRepository

      ){}

      async createStockTransfer(req:StockTransferDto):Promise<CommonResponseModel>{

        // console.log(req,'@@@@@@@@@@@@@@@@@@@@@@2')
        try{
          let getCount = await this.repo.findAndCount({where:{challanType:'Stock Transfer'}});
          // console.log(getCount);
          // console.log(getCount[1])
          let getFromPlant = await this.plantsRepository.findOne({where:{plantId:req.fromLocation}})
          let getToPlant = await this.plantsRepository.findOne({where:{plantId:req.toLocation}})
          const entity= new StocktransferEntity()
          entity.challanType=req.challanType
          entity.itemType=req.itemType
          entity.challanNo="STR/"+getFromPlant.plantCode+"/"+getToPlant.plantCode+"/24-25/"+(getCount[1]+1)
          entity.challandate=req.challandate
          entity.poNo=req.poNo
          entity.billFrom=req.billFrom
          entity.purpose=req.purpose
          entity.addressCode=req.addressCode
          entity.addressDetails=req.addressDetails
          entity.receipent=req.receipent
          entity.employee=req.employee
          entity.refOrder=req.refOrder
          entity.value=req.value
          entity.lr=req.lr
          entity.weight=req.weight
          entity.rolls=req.rolls
          entity.status=req.status
          entity.eWayBill=req.eWayBill
          entity.fromLocation=req.fromLocation
          entity.fromRack=req.fromRack
          entity.toLocation=req.toLocation
          entity.remarks=req.remarks
          entity.remarks=req.remarks
          entity.status='OPEN'
          entity.createdUser=req.createdUser
          entity.refNo=getCount[1]+1
        const itemData=[]
        for(const res of req.itemsInfo){
          // console.log(res,'################')
          const item=new StockItemstransferEntity()
          item.itemType=res.itemType
          item.itemId=res.m3ItemId
          item.buyerId=res.buyerId
          item.excelNo=res.xlNo
          item.loaction=res.rackPositionId
          item.rackId=res.rackId
          item.quantity=res.quantity
          item.sts=res.stcQnuantity
          item.dcQty=res.dcQuantity
          item.allocatedQty=res.allocatedQty
          item.uomId=res.uomId
          item.remarks=res.remarks
          item.stockId=res.stockId
          itemData.push(item)
        }
        entity.itemInfo=itemData
        const save = await this.repo.save(entity)
        if(save){
          for(const stock of req.itemsInfo){
            const stockUpdate = await this.stockRepo.update({id:stock.stockId},{dcQuantity: stock.dcQuantity})
            // console.log(stockUpdate)
          }
        }
        if(save){
          return new CommonResponseModel(true,1,'Stock transfered Sucessfully')
        }else{
          return new CommonResponseModel(false,0,'Something Wwnt Wrong')
        }

        }catch(err){
          throw err

        }
      }

      // const stockUpdate = await this.stockRepo.update({id:stock.stockId},{negativeStock:() => `allocated_quantity - quantity`})
      async CreateNegativeStock(req:StockTransferDto):Promise<CommonResponseModel>{
          try{
            // let today = new Date();
            // let currentYear = today.getFullYear();
            // let currentMonth = today.getMonth();
            // let fromYear = currentMonth < 4 ? currentYear - 1 : currentYear;
            // let toYear = fromYear + 1;
            // let finYear = `${fromYear.toString().substr(-2)}-${toYear.toString().substr(-2)}`;
            let getCount = await this.repo.findAndCount({where:{challanType:'Stock Negative'}});
            let getFromPlant = await this.plantsRepository.findOne({where:{plantId:req.fromLocation}})

            const challanNo= await this.repo.createQueryBuilder('challan_no')
            .select(['max(challan_no.id) as MaxChallanaId'])
            .getRawOne();
            let count=challanNo.MaxChallanaId+1;
            let refNo = count.toString().padStart(4, '0');
            
            const entity= new StocktransferEntity()
            entity.challanType=req.challanType
            entity.itemType=req.itemType
            entity.challanNo="STR/"+getFromPlant.plantCode+"/24-25/"+(getCount[1]+1)
            entity.challandate=req.challandate
            entity.poNo=req.poNo
            entity.billFrom=req.billFrom
            entity.purpose=req.purpose           
            entity.employee=req.employee
            entity.refOrder=req.refOrder
            entity.value=req.value
            entity.lr=req.lr
            entity.weight=req.weight
            entity.rolls=req.rolls
            entity.status=req.status
            entity.eWayBill=req.eWayBill
            entity.fromLocation=req.fromLocation
            entity.fromRack=req.fromRack
            entity.toLocation=req.toLocation
            entity.remarks=req.remarks
            entity.status='OPEN'
            entity.createdUser=req.createdUser
            entity.refNo=0
            const itemData=[]
            for ( const res of req.itemsInfo){
              const item= new StockItemstransferEntity()
              item.itemType=res.itemType
              item.itemId=res.m3ItemId
              item.buyerId=res.buyerId
              item.excelNo=res.xlNo
              item.loaction=res.rackPositionId
              item.rackId=res.rackId
              item.stockId=res.stockId
              item.quantity=res.quantity
              item.sts=res.stcQnuantity
              item.negativeStock=res.negativeStock
              item.allocatedQty=res.allocatedQty
              item.uomId=res.uomId
              item.remarks=res.remarks
              itemData.push(item)
            }
        
        entity.itemInfo=itemData
        const save =await this.repo.save(entity)
        if(save){
        for ( const stock of req.itemsInfo){
          const stocknegativeupdate= await this.stockRepo.update({id:stock.stockId},{negativeStock:stock.negativeStock})
        }
        }
        if(save){
          return new CommonResponseModel(true,1,'Stock Negative Sucessfully')
        }else{
          return new CommonResponseModel(false,0,'Something Went Wrong')
        }
      }catch(err){
        throw err

      }
        }

      async getStockTransfers():Promise<CommonResponseModel>{
        try{
          let data = "select s.*,st.challan_no AS challanNo,fp.plant_name AS fromPlant,tp.plant_name AS toPlant,sit.item_type AS itemType, if(sit.item_type = 'FABRIC', fi.description,ti.trim_code) AS item, dc_qty AS dcQty,st.status,sit.id AS stockTransferItemId from stock_items_transfer sit left join m3_items fi on fi.m3_items_Id = sit.item_id and sit.item_type = 'FABRIC' left join m3_trims ti on ti.m3_trim_Id = sit.item_id and sit.item_type != 'FABRIC' left join stock_transfer st on sit.stock_transfer_id = st.id left join stocks s on s.id = sit.stock_id left join plants fp on fp.plant_id = st.from_loaction left join plants tp on tp.plant_id = st.to_location where st.challan_type = 'Stock Transfer'"
          const records = await this.repo.query(data)
          if(records.length > 0){
            return new CommonResponseModel(true,1,"Stock Transfers retrived successfully. ",records);
          }
          else{
            return new CommonResponseModel(false,0,"No data found. ",);
          }
        }catch(err){
          throw err
        }
      }


      async getStockNegatives():Promise<CommonResponseModel>{
        try{
          let data = "select s.*,st.challan_no AS challanNo,fp.plant_name AS fromPlant,tp.plant_name AS toPlant,sit.item_type AS itemType, if(sit.item_type = 'FABRIC', fi.description,ti.trim_code) AS item, dc_qty AS dcQty,st.status,sit.id AS stockTransferItemId,sit.negative_stock AS negativeQty from stock_items_transfer sit left join m3_items fi on fi.m3_items_Id = sit.item_id and sit.item_type = 'FABRIC' left join m3_trims ti on ti.m3_trim_Id = sit.item_id and sit.item_type != 'FABRIC' left join stock_transfer st on sit.stock_transfer_id = st.id left join stocks s on s.id = sit.stock_id left join plants fp on fp.plant_id = st.from_loaction left join plants tp on tp.plant_id = st.to_location where st.challan_type = 'Stock Negitive'"
          const records = await this.repo.query(data)
          if(records.length > 0){
            return new CommonResponseModel(true,1,"Stock Negitives retrived successfully. ",records);
          }
          else{
            return new CommonResponseModel(false,0,"No data found. ",);
          }
        }catch(err){
          throw err
        }
      }

      async receiveStock(req:any):Promise<CommonResponseModel>{
        try{
          let data = "select st.challan_no AS challanNo,fp.plant_name AS fromPlant,tp.plant_name AS toPlant, if(sit.item_type = 'FABRIC', fi.description,ti.trim_code) AS item, dc_qty AS dcQty from stock_items_transfer sit left join m3_items fi on fi.m3_items_Id = sit.item_id and sit.item_type = 'FABRIC' left join m3_trims ti on ti.m3_trim_Id = sit.item_id and sit.item_type != 'FABRIC' left join stock_transfer st on sit.stock_transfer_id = st.id left join stocks s on s.id = sit.stock_id left join plants fp on fp.plant_id = st.from_location left join plants tp on tp.plant_id = st.to_loaction where st.challan_type = 'Stock Negative'"
          const records = await this.repo.query(data)
          if(records.length > 0){
            return new CommonResponseModel(true,1,"Stock Transfers retrived successfully. ",records);
          }
          else{
            return new CommonResponseModel(false,0,"No data found. ",);
          }
        }catch(err){
          throw err
        }
      }

  
}
